export default "__VITE_ASSET__BSWngXkL__"